import {hitAlgolytics} from "@pg-mono/algolytics";

import {CreditAlgolyticsViewType} from "../types/CreditAlgolyticsViewType";

export enum ModalEventSource {
    INTERVIEW = 1,
    CREDIT_ASK = 2,
    WORTHINESS_CHECK = 3,
    WORTHINESS_CALC = 4,
    CREDIT_RATING = 5
}

export interface ICreditModalAlgolytics {
    source_id: ModalEventSource;
    view_type: CreditAlgolyticsViewType;
    sent: boolean | null;
}

export const CreditModalEvent = (eventPayload: ICreditModalAlgolytics) => {
    hitAlgolytics("credit_interview", {
        ...eventPayload
    });
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {CreditAlgolyticsViewType} from "../types/CreditAlgolyticsViewType";

export enum ModalEventSource {
    INTERVIEW = 1,
    CREDIT_ASK = 2,
    WORTHINESS_CHECK = 3,
    WORTHINESS_CALC = 4,
    CREDIT_RATING = 5
}

export interface ICreditModalAlgolytics {
    source_id: ModalEventSource;
    view_type: CreditAlgolyticsViewType;
    sent: boolean | null;
}

export const CreditModalEvent = (eventPayload: ICreditModalAlgolytics) => {
    hitAlgolytics("credit_interview", {
        ...eventPayload
    });
};
